export type { playerType } from "./VideoPlay.type";
import VideoPlay from "./VideoPlay";
export default VideoPlay;
